module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-play-89c6207b.svg";